/**
 * The Rowted mark — traced from the mockup SVG in
 * `/design/mockups/01-global-header/html/header-main.html`.
 *
 * Plan §11 decision 1: Direction A, threaded rows. A tenant that uploads its
 * own logo replaces this everywhere, including the portal and the crew iPad.
 */
export function RowtedMark({ size = 28 }: { size?: number }) {
  return (
    <svg viewBox="0 0 64 64" width={size} height={size} aria-hidden className="shrink-0">
      <line x1="12" y1="18" x2="52" y2="18" stroke="rgb(var(--color-accent-tint))" strokeWidth="9" strokeLinecap="round" />
      <line x1="12" y1="32" x2="52" y2="32" stroke="rgb(var(--color-accent-tint))" strokeWidth="9" strokeLinecap="round" />
      <line x1="12" y1="46" x2="52" y2="46" stroke="rgb(var(--color-accent-tint))" strokeWidth="9" strokeLinecap="round" />
      <path
        d="M18 18 H36 C45 18 45 32 36 32 H28 C19 32 19 46 28 46 H42"
        fill="none" stroke="rgb(var(--color-accent))" strokeWidth="5"
        strokeLinecap="round" strokeLinejoin="round"
      />
      <circle cx="14" cy="18" r="4.2" fill="rgb(var(--color-accent))" />
      <circle cx="49" cy="46" r="5.5" fill="rgb(var(--color-accent))" />
      <circle cx="49" cy="46" r="2" fill="rgb(var(--color-surface))" />
    </svg>
  )
}

export function RowtedLogo({ tenantName }: { tenantName?: string | null }) {
  return (
    <span className="flex shrink-0 items-center gap-[7px]">
      <RowtedMark />
      {/* The wordmark goes on a phone; the mark alone still says whose app
          this is, and 90px of brand is 90px the search box does not get. */}
      <b className="hidden max-w-[140px] truncate text-[15px] tracking-[-0.02em] text-text sm:block">
        {tenantName ?? 'rowted'}
      </b>
    </span>
  )
}
